import { createI18n } from 'vue-i18n'
import enHK from './locales/en-HK.json'
import zhHK from './locales/zh-HK.json'
import zhCN from './locales/zh-CN.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'

const messages = {
  'en-HK': enHK,
  'zh-HK': zhHK,
  'zh-CN': zhCN,
  'ja': ja,
  'ko': ko
}

const i18n = createI18n({
  legacy: false, // 重点：必须加这行
  locale: 'en-HK',
  fallbackLocale: 'en-HK',
  messages,
})

export default i18n